import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HOME } from "@/constants/testIds";

const FAQS = [
  {
    q: "Will clients know I used AI?",
    a: "No — MACHA is tuned to keep your voice, your phrasing, and your quirks. It writes proposals that sound like a thoughtful freelancer, not a chatbot.",
  },
  {
    q: "Which marketplaces does it support?",
    a: "Upwork, Fiverr, Freelancer.com, Toptal, Contra and PeoplePerHour. You can also use MACHA for direct client email or LinkedIn DMs.",
  },
  {
    q: "Does it work for non-English clients?",
    a: "Yes. MACHA handles 24+ languages with native-sounding tone, including Spanish, German, French, Portuguese, Japanese, and Arabic.",
  },
  {
    q: "Will my data be used to train models?",
    a: "Never. Your proposals, drafts and conversations are private by default and excluded from any model training.",
  },
  {
    q: "Can I cancel any time?",
    a: "Yes, with one click — and you can export all your saved replies before you go. No retention emails, no friction.",
  },
];

export function FAQ() {
  return (
    <section
      data-testid={HOME.faqSection}
      className="border-t border-border bg-card/40"
    >
      <div className="mx-auto w-full max-w-3xl px-5 py-24 sm:px-8 sm:py-32">
        <div className="text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">
            FAQ
          </p>
          <h2 className="mt-3 text-balance text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            Honest answers to fair questions.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 w-full">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`faq-${i}`}
              data-testid={HOME.faqItem(i + 1)}
              className="border-b border-border last:border-b-0"
            >
              <AccordionTrigger className="py-5 text-left text-[15px] font-medium text-foreground hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-[14px] leading-relaxed text-muted-foreground">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
